@if (items) {
  <ion-list>
    @for (item of items; track item) {
      <ion-item (click)="this.popoverCtrl.dismiss({selected: item})">
        {{item.title}}
      </ion-item>
    }
  </ion-list>
}
